// extracted by mini-css-extract-plugin
module.exports = {"wireframe":"wireframe_wireframe__zw_Jr","rect":"wireframe_rect__emmMJ","round":"wireframe_round__BMVtC","circle":"wireframe_circle__0CRzX"};